import { observer } from 'mobx-react-lite'
import { store } from '../../../stores/Store'
import React from 'react'
import { LinearProgress } from '@mui/material'

interface WorkflowTemplateListProps {
    onSelect: Function
}

export default observer(function WorkflowTemplateList ({onSelect}: WorkflowTemplateListProps) {

    const { workflows } = store.AppStore
    const [loading, setLoading] = React.useState(true)

    React.useEffect(() => {
        setLoading(true)

        store.AppStore.getWorkflows().finally(() => {
            setLoading(false)
        })
    }, [])

    var groupedWorkflows = {"Global": []}
    if (workflows.length) {
        [...workflows].sort((a, b) => a.label.localeCompare(b.label)).forEach((workflow) => {
            var groupKey = workflow.accountUid ? workflow.accountUid : "Global"
            if (groupKey in groupedWorkflows) {
                groupedWorkflows[groupKey].push(workflow)
            } else {
                groupedWorkflows[groupKey] = [workflow]
            }
        })
    }

    return (
        <div style={{display: "grid", gap: "20px", padding: "0 20px 20px 0"}}>
            {Object.keys(groupedWorkflows).map((groupKey, i) => {
                
                var workflowGroup = groupedWorkflows[groupKey]
                var account = store.NodeStore.accounts.find(a => a.uid === groupKey)
                
                return (
                    <div key={i} className="tool-section" style={{maxWidth: "600px"}}>
                        <div className="tool-table">
                            {!groupKey ? (
                                <small style={{color: "#adadad"}}>Global Workflows</small>
                            ) : (
                                <small style={{color: "#adadad"}}>{account ? account.label : groupKey} Workflows</small>
                            )}

                            <div style={{display: "grid", gap: "10px", padding: "10px 0"}}>
                                {workflowGroup?.map((workflow, i) => (
                                    <WorkflowTemplateListItem key={i} onSelect={onSelect} workflow={workflow} />
                                ))}

                                {!workflowGroup?.length ? (
                                    <span>No Workflows</span>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
})


function WorkflowTemplateListItem ({workflow, onSelect}) {
    return (
        <div onClick={() => onSelect(workflow)}>
            <span className="link">{workflow.label}</span>
            <small>{workflow.description}</small>
        </div>
    )
}